/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type plannedVsSpentComponent_viewer = {
    readonly insightComponentsData: {
        readonly plannedVsSpent: {
            readonly minutesPlanned: number | null;
            readonly minutesSpent: number | null;
        } | null;
    } | null;
    readonly " $refType": "plannedVsSpentComponent_viewer";
};
export type plannedVsSpentComponent_viewer$data = plannedVsSpentComponent_viewer;
export type plannedVsSpentComponent_viewer$key = {
    readonly " $data"?: plannedVsSpentComponent_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"plannedVsSpentComponent_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isProjectGroupType",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "plannedVsSpentComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "isProjectGroupType",
              "variableName": "isProjectGroupType"
            },
            {
              "kind": "Variable",
              "name": "projectId",
              "variableName": "projectId"
            }
          ],
          "concreteType": "PlannedVsSpent",
          "kind": "LinkedField",
          "name": "plannedVsSpent",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesPlanned",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesSpent",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '3acd86073a9dfd7059b4882f42edd624';
export default node;
